import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { CtUser } from 'containers';
import { MyPageTemplate, MyPageTitle } from 'components';

class CtProfile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <MyPageTemplate>
        <MyPageTitle
          small
          title={defineMessages(formatMessage({ id: 'UserEditArea_1', defaultMessage: '내 정보 수정' }))}
        />
        <CtUser />
      </MyPageTemplate>
    );
  }
}

export default injectIntl(CtProfile);


// WEBPACK FOOTER //
// ./src/script/containers/user/CtProfile.js